import React from "react";

export default class AreYouAProfessionalDumpster extends React.Component 
{
    render() 
    {    
        return (
            <section className="banner-contractor dumpster">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 pl-m-0">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-5 order-1 order-md-0 text-center p-m-0">
                                    <img className="banner-img" src='/images/pro-dumpster-service.webp' alt="Pro dumpster service"/>
                                </div>
                                <div className="col-12 col-md-7 text-center order-0 order-md-1">
                                    <h2>Are You a Professional Waste Hauler?</h2>
                                    <h4 dangerouslySetInnerHTML={{__html: "More customers visit Hometown Dumpster</br>to hire a disposal service than any other source."}}></h4>
                                    <a className="btn btn-success btn-sm btn-lite" href='/pro/register'>Pros Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
};